import ClickOutside from './ClickOutside';

export default ClickOutside;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/click-outside/index.js
// module id = null
// module chunks = 